<!--
 * @Autor: yingna.gao
 * @Date: 2022-07-06 15:07:22
 * @LastEditTime: 2022-07-18 16:37:23
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/cockpit/components/alarm-today-statistics.vue
-->
<template>
  <el-card class="alarm-today-statistics-wrapper">
    <div slot="header" class="clearfix">
      <span>今日报警统计</span>
    </div>
    <div>
      <div class="tody-order-statistics-content">
        <div class="content-item">
          <p class="content-item-text">待处理</p>
          <p class="content-item-number redColor">{{ todayWarnStatistic }}</p>
        </div>
        <div class="content-item">
          <svg-icon icon-class="warn" class="warn-icon"></svg-icon>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "AlarmTodayStatistics",
  data() {
    return {
      todayWarnStatistic: "0"
    };
  },
  created() {
  }
};
</script>

<style lang="scss" scoped>
.alarm-today-statistics-wrapper{
    width:100%;
    height:100%;
}
.tody-order-statistics-content {
  height: 82px;
  display: flex;
  text-align: center;
  align-items: center;
  .content-item {
    flex: 1;
    .content-item-text {
      margin-bottom: 8px;
      font-size: 16px;
      color: #505363;
    }
    .content-item-number {
      font-size: 32px;
      color: rgba(0, 0, 0, 0.85);
      font-weight: 600;
    }
    .redColor {
      color: #e02020;
    }
    .warn-icon {
      width: 2.5em;
      height: 2.5em;
    }
  }
}
.alarm-today-statistics-wrapper.el-card.is-always-shadow {
  box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.03) !important;
}
.alarm-today-statistics-wrapper.el-card {
  border: 1px solid #ebecef !important;
}
.alarm-today-statistics-wrapper{
    ::v-deep .el-card__body {
    padding: 16px 24px !important;
   }
   ::v-deep .el-card__header {
    padding: 0px 24px !important;
    font-size: 16px !important;
    color: #21252e !important;
    font-weight: 600 !important;
    height: 44px;
    line-height: 44px;
    }
}
</style>
